export const SITE_URL = "https://suneditor.com";
export const SITE_NAME = "SunEditor";

/* Site-wide positioning copy — shared by root metadata, the home page and JSON-LD. */
export const SITE_TITLE = "SunEditor — Modular WYSIWYG HTML Editor (MIT)";
export const SITE_DESCRIPTION =
	"Modular WYSIWYG HTML editor with zero runtime dependencies. 30+ built-in plugins — enable only what you need. MIT licensed, no cloud, no account.";
/** Shorter subtitle for the default Open Graph card. */
export const SITE_CARD_DESCRIPTION = "Modular WYSIWYG HTML editor — zero runtime dependencies, 30+ plugins, MIT licensed.";
